import { memo, useCallback } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { BORDER_RADIUS, COLOR } from '@/globalStyles';
import { ROUTES } from '@/pages/Routing/Routing';
import tmpAvatar from '@/resources/image/profile_avatar.svg';

export interface IProfilePictureProps {
    className?: string;
    profilePicture?: ArrayBuffer | string | null;
    size?: string;
    withRedBorder?: boolean;
    userId?: string;
}

const ProfilePicture = ({ profilePicture, userId, className }: IProfilePictureProps) => {
    const navigate = useNavigate();

    const redirect = useCallback(() => {
        if (!userId) return;
        navigate(generatePath(ROUTES.USER_PROFILE, { userId }));
    }, [navigate, userId]);

    return (
        <div data-testid="profilePicture" onClick={redirect}>
            <img
                className={className}
                src={typeof profilePicture === 'string' && profilePicture ? profilePicture : tmpAvatar}
                alt="profile_image"
                onError={({ currentTarget }) => {
                    currentTarget.src = tmpAvatar;
                }}
            />
        </div>
    );
};

const Memoized = memo(ProfilePicture);
const Styled = styled(Memoized)<{ size?: string; withRedBorder?: boolean }>`
    display: flex;
    --size: ${({ size }) => size};
    border-radius: ${BORDER_RADIUS.round};
    background-color: ${COLOR.white};
    width: var(--size);
    height: var(--size);

    ${({ userId }) =>
        userId &&
        css`
            cursor: pointer;
        `}

    ${({ withRedBorder }) =>
        withRedBorder &&
        css`
            border: 2px solid ${COLOR.redWildWatermelon};
        `}
`;

export default Styled;
